import { useState, useCallback } from 'react';

export const useSimulatorPageLogic = () => {    // Using proper naming convention for state variables
    const [clientState, setClientState] = useState({});
    const [propertyState, setPropertyState] = useState({});
    const [creditAnalysisState, setCreditAnalysisState] = useState({});
    const [walletState, setWalletState] = useState({});

    // Create derived variables with the same names used throughout the component
    const clientData = clientState;
    const propertyData = propertyState;
    const creditAnalysisData = creditAnalysisState;
    const walletData = walletState;
    const [simulationResult, setSimulationResult] = useState(null);
    const [isPrintEnabled, setIsPrintEnabled] = useState(false);
    const [showResult, setShowResult] = useState(false);
    const [totalIncome, setTotalIncome] = useState(0);
    const [resetKey, setResetKey] = useState(0);
    const [showWalletCard, setShowWalletCard] = useState(false);

    const [isPropostaIdeal, setIsPropostaIdeal] = useState(true);
    const [parcelamentoMaximoPropostaIdeal, setParcelamentoMaximoPropostaIdeal] = useState(null);

    const handleClientDataChange = useCallback((data) => {
        setClientState(data);
        setShowResult(false);
        setIsPrintEnabled(false);
    }, []);
    const handlePropertyDataChange = useCallback((data) => {
        setPropertyState(data);
        setShowResult(false);
        setIsPrintEnabled(false);
    }, []);
    const handleCreditAnalysisDataChange = useCallback((data) => {
        setCreditAnalysisState(data);
        setShowResult(false);
        setIsPrintEnabled(false);
    }, []);
    const handleWalletDataChange = useCallback((data) => {
        if (simulationResult) {
            setWalletState({
                ...data,
                qtdParcelaIdeal: simulationResult.proposta.quantidadeParcelasMensais,
                qtdParcelasMaxima: parcelamentoMaximoPropostaIdeal
            });
            return;
        }

        setWalletState(data);
    }, [simulationResult, parcelamentoMaximoPropostaIdeal]);

    const handleTotalIncomeChange = useCallback((value) => {
        setTotalIncome(value);
    }, []);

    const handleSimulationComplete = useCallback((result) => {
        setSimulationResult(result);
        setShowWalletCard(true);
        setShowResult(true);
        setIsPrintEnabled(true);

        if (isPropostaIdeal) {
            setParcelamentoMaximoPropostaIdeal(result.propostaRequest.parametrosProposta.parametrosRatingSelecionados.parcelamentoMaximo)
        }

        setIsPropostaIdeal(false);
        setTimeout(() => {
            document.getElementById('resultadoSimulacao')?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    }, []);

    const handleClearForm = useCallback(() => {
        setClientState({});
        setPropertyState({});
        setCreditAnalysisState({});
        setWalletState({});
        setSimulationResult(null);
        setIsPrintEnabled(false);
        setShowResult(false);
        setTotalIncome(0);
        setShowWalletCard(false);
        setIsPropostaIdeal(true);

        // forçar a recriação dos componentes
        setResetKey(prev => prev + 1);

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    const handlePrintClick = useCallback(() => {
        if (simulationResult) {
            // Esconde qualquer notificação ou elemento flutuante
            document.querySelectorAll('.toast, .modal, .popup').forEach(el => {
                el.style.display = 'none';
            });

            // Pequeno timeout para garantir que o DOM foi atualizado
            setTimeout(() => {
                window.print();
            }, 100);
        }
    }, [simulationResult]); return {
        resetKey,
        clientData,
        propertyData,
        creditAnalysisData,
        walletData,
        simulationResult,
        isPrintEnabled,
        showResult,
        totalIncome,
        showWalletCard,
        isPropostaIdeal,
        parcelamentoMaximoPropostaIdeal,
        setShowWalletCard,
        setClientData: handleClientDataChange,
        setPropertyData: handlePropertyDataChange,
        setCreditAnalysisData: handleCreditAnalysisDataChange,
        setWalletData: handleWalletDataChange,
        handleTotalIncomeChange,
        handlePrintClick,
        handleSimulationComplete,
        handleClearForm,
        setIsPrintEnabled,
        setShowResult
    };
};